import {useEffect, useState} from "react";
import {WorksiteTypesWithIdSchema} from "@feature/types";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

export const useWorksiteTypes = () => {

  // hooks
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [loading, setLoading] = useState(false);
  const [data, setData]
    = useState<WorksiteTypesWithIdSchema[]>();

  // handlers
  const fetch = async () => {
    setLoading(true);
    try {
      return await countryApiRequest!.get("/worksite_types/all") as unknown as WorksiteTypesWithIdSchema[];
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetch().then(setData);
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return {loading, data}
}